import { differenceInMinutes, getHours, getMinutes, isBefore, set } from 'date-fns';
import { format, fromZonedTime, toZonedTime } from 'date-fns-tz';
export const createISODateString = (date, hours, minutes) => {
    // the Date constructor always interprets the parameters in the local system timezone, not in the timezone we want (Lithuania).
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
};
export const getLocalDateTime = (dateTime, pattern) => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return format(dateTime, pattern, { timeZone: userTimeZone });
};
export const isLocalExpirationWithin30Minutes = (expiresAt) => {
    if (!expiresAt) {
        return false;
    }
    const expiresDate = new Date(expiresAt);
    const expireHours = getHours(expiresDate);
    const expireMinutes = getMinutes(expiresDate);
    const closingTime = set(new Date(), { hours: expireHours, minutes: expireMinutes });
    const isBeforeExpiration = isBefore(new Date(), closingTime);
    const isLessThan30Minutes = differenceInMinutes(closingTime, new Date()) < 30;
    return isBeforeExpiration && isLessThan30Minutes;
};
export const getLocalExpirationTime = (expiresAt) => {
    if (!expiresAt) {
        return '';
    }
    return getLocalDateTime(expiresAt, 'HH:mm');
};
const getDiffTo22Lithuania = () => {
    const lithuaniaTimeZone = 'Europe/Vilnius';
    const now = new Date();
    const lithuanianNow = toZonedTime(now, lithuaniaTimeZone);
    const target22InLithuania = set(lithuanianNow, { hours: 22, minutes: 0, seconds: 0, milliseconds: 0 });
    const target22UTC = fromZonedTime(target22InLithuania, lithuaniaTimeZone);
    return target22UTC.getTime() - now.getTime();
};
export const getMinutesBefore22inLithuania = () => {
    const diffMs = getDiffTo22Lithuania();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    if (diffMinutes > 30) {
        return '30';
    }
    return String(diffMinutes);
};
export const isLessThan30MinutesTo22 = () => {
    const diffMs = getDiffTo22Lithuania();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    return diffMinutes <= 30;
};
export const mapLithuanianToLocalTime = (lithuanianTimeStr) => {
    const [hours, minutes] = lithuanianTimeStr.split(':').map(Number);
    const lithuanianTimeZone = 'Europe/Vilnius';
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = new Date();
    const lithuanianNow = toZonedTime(now, lithuanianTimeZone);
    const lithuanianDateTime = set(lithuanianNow, { hours, minutes, seconds: 0, milliseconds: 0 });
    const utcDate = fromZonedTime(lithuanianDateTime, lithuanianTimeZone);
    return format(utcDate, 'HH:mm', { timeZone: userTimeZone });
};
